/* eslint-disable camelcase */
// import analytics from '@/analytics'
export interface CustomQuestionAnalytics {
  experimentId: string | number;
  test_type: 'Template' | string;
  test_id: string | number;
  template_title: string; // is there a type that has each template name?
  template_id: string | number;
  draft: boolean;
  tapId: string | number;
  tapName: string;
  tapType: 'betas' | 'client' | 'dev' | 'inactive' | 'sales';
  questionId: string | number;
  questionType: 'single-select' | 'multi-select' | 'textarea' | 'rate-only';
}

// Not enforcing type because its not important enough to throw an error if its misshapen
export default function sendCustomQuestionAnalytics (
  fullAnalytics: CustomQuestionAnalytics | any
) {
  console.log('Full analytics coming in for customQuestion:', fullAnalytics)
  // analytics.track('Custom Question Added', fullAnalytics)
}
